<template>
  <div>
    <b-navbar :sticky="true" class="main-navbar">
      <b-container>
        <b-navbar-brand class="main-navbar__logo">
          <img
            class="main-navbar__logo-img"
            :src="logoBDTop"
            @click="redirectBDweb"
            alt="bd-logo"
            tabindex="0"
          />
          <img
            class="main-navbar__logo-img ml-3"
            :src="logoESHTop"
            @click="redirectLogin"
            alt="esh-logo"
            tabindex="0"
          />
          <div class="main-navbar__logo-text ml-3" @click="redirectLogin" tabindex="0">
            <div class="title1 my-2">{{ $t("bd") }}</div>
            <div class="title2 my-1">{{ $t("subtitle") }}</div>
          </div>
        </b-navbar-brand>

        <div class="header__right ml-auto lg">
          <div class="header__item"  @click="redirectBDabout" tabindex="0">
            <a><i class="fas fa-building mr-2"></i>{{ $t("about") }}</a>
          </div>
          <div class="header__item" @click="redirectFAQ" v-if="site != 'CPS'" tabindex="0">
            <a><i class="fas fa-comment-dots mr-2"></i>{{ $t("faq") }}</a>
          </div>
          <div class="header__item" @click="redirectUserManuel" tabindex="0">
            <a><i class="fas fa-book mr-2"></i>{{ $t("manual") }}</a>
          </div>
          <div class="header__item bd-blue" @click="redirectFontsize" tabindex="0">
            <i class="fas fa-font mr-2"></i>{{ $t("font-size") }}
          </div>
          <b-dropdown
            id="lang"
            class="header__item lang-class"
            menu-class="lang-menu-class"
            toggle-class="lang-button"
            no-caret
          >
            <template #button-content
              ><i class="fas fa-globe-asia mr-2"></i
              >{{ $t("language") }}</template
            >
            <b-dropdown-item
              v-for="lang of langs"
              :key="lang.value"
              @click="setLang(lang)"
              >{{ lang.text }}</b-dropdown-item
            >
          </b-dropdown>
          <div class="header__item">
            <VHelpPro :editable="false" modalSize="xl"></VHelpPro>
            {{ $t("help") }}
          </div>
        </div>
      </b-container>
    </b-navbar>
  </div>
</template>

<script>
import logoBDTop from "@/assets/login/logo-BD-top.png";
import logoESHTop from "@/assets/EshLogo/MAC OS-512px/png/ESH logo-full colour-512px-31012022-OL-03.png";
import { localize, localeChanged } from "vee-validate";
import { VHelpPro } from "@unify/v-help-pro";
import { validateInvitationCode } from "@/api/request-registration.api";
import { setLocale } from "@/services/locale.service";
import { EshApi } from "@/api";

export default {
  components: {
    VHelpPro,
  },
  data() {
    return {
      logoBDTop,
      logoESHTop,
      langs: [
        { text: "English", value: "en" },
        { text: "繁體", value: "zh_hk" },
        { text: "简体", value: "zh_cn" },
      ],
      helpLocales: "",
      site: ''
    };
  },
  async created() {
    const enableEpsLoginPage = (await EshApi.getRegistrationPublicSystemSetting()).EnableEpsLoginPage;
    if (enableEpsLoginPage) {
      this.site = 'CPS'
    }
    this.$nextTick(() => {
      const link = document.querySelector('a[aria-disabled]')
      if (link) {
        link.removeAttribute('aria-disabled')
      }
    })
  },
  methods: {
    async setLang(lang) {
      setLocale(lang.value);
      if(location.hash.indexOf('lang')>0) {
        location.hash = '#/login'
        location.reload();
      }
      else location.reload();
    },
    redirectFontsize() {
      const locale = this.$i18n.locale;
      switch(true) {
        case locale.startsWith('en'):
          window.open(`https://www.gov.hk/en/about/textsize/`);
          break;
        case locale === 'zh_hk':
          window.open(`https://www.gov.hk/tc/about/textsize/`);
          break;
        case locale === 'zh_cn':
          window.open(`https://www.gov.hk/sc/about/textsize/`);
          break;
      }
    },
    redirectFAQ() {
      this.$router.push({ name: "FAQ" });
    },
    redirectBDweb() {
      const locale = this.$i18n.locale;
      switch(true) {
        case locale.startsWith('en'):
          window.open(`https://www.bd.gov.hk/en/index.html`);
          break;
        case locale === 'zh_hk':
          window.open(`https://www.bd.gov.hk/tc/index.html`);
          break;
        case locale === 'zh_cn':
          window.open(`https://www.bd.gov.hk/sc/index.html`);
          break;
      }
    },
    redirectLogin() {
      console.log("window.location.host",window.location);
      if(window.location.hash.includes('login-public')){
        this.$router.push({name:"LoginPublic"})
      }else{
        // login cps page
        if (this.site == 'CPS') {
          this.$router.push({ name: "LoginCps" });
        }
        // login ess page
        else {
          this.$router.push({ name: "Login" });
        }
      }
    },
    redirectBDabout() {
      const locale = this.$i18n.locale;
      switch(true) {
        case locale.startsWith('en'):
          window.open(`https://www.bd.gov.hk/en/resources/online-tools/electronic-submission-hub/index.html`);
          break;
        case locale === 'zh_hk':
          window.open(`https://www.bd.gov.hk/tc/resources/online-tools/electronic-submission-hub/index.html`);
          break;
        case locale === 'zh_cn':
          window.open(`https://www.bd.gov.hk/sc/resources/online-tools/electronic-submission-hub/index.html`);
          break;
      }
    },
    redirectUserManuel() {
      // login cps page
      if (this.site == 'CPS') {
        window.open(`https://${window.location.host}/manual/cps/BD_ESH_CPS_Application_User_Manual.pdf`);
      }
      // login ess page
      else {
        const locale = this.$i18n.locale;
        switch(true) {
          case locale.startsWith('en'):
            window.open(`https://esh.bd.gov.hk/manual/ess/BD_ESH_ESS_Application_User_Manual.pdf`);
            break;
          case locale === 'zh_hk':
            window.open(`https://esh.bd.gov.hk/manual/ess/BD_ESH_ESS_Application_User_Manual_hk.pdf`);
            break;
          case locale === 'zh_cn':
            window.open(`https://esh.bd.gov.hk/manual/ess/BD_ESH_ESS_Application_User_Manual_cn.pdf`);
            break;
        }
      }
    }
  },
};
</script>

<i18n src="@/locales/common.locale"></i18n>

<i18n src="@/locales/esh.locale"></i18n>